import wixLocation from 'wix-location';
import {session} from 'wix-storage'

$w.onReady(function () {
    if (session.getItem('CartCount')) {
        let cartCount = session.getItem('CartCount')
		$w("#textCartCount").text = '' + cartCount;
		$w("#groupCart").show();
    }
});

export function textCartCount_click(event) {
	wixLocation.to('/checkout')
}

export function cartIcon_click(event) {
	wixLocation.to('/checkout')
}